import moment from 'moment'

import type { DownloadPeriod } from '../type'

export const LIMIT_DAYS_DOWNLOAD_CSV = 90

const FORMAT_DATE = 'YYYYMMDD'

// WHY: クイック選択（今日・今月）の終端は現在時刻付き、日付ピッカー選択日は 00:00 と時刻成分が混在する。
// 日粒度に丸めないと実差 90.x 日が diff 切り捨てで 90 になり判定をすり抜ける。
// BE(TB-1871) も ChronoUnit.DAYS.between(from, to) > 90 の日数差比較なので、丸めることで判定基準も揃う。
export const isOverDownloadPeriod = (period: DownloadPeriod): boolean =>
  moment(period.endDate).startOf('day').diff(moment(period.startDate).startOf('day'), 'days') >
  LIMIT_DAYS_DOWNLOAD_CSV

export const isBeforeStartDate = (period: DownloadPeriod): boolean =>
  moment(period.endDate).isBefore(period.startDate, 'day')

export const isDisabledDownload = (period: DownloadPeriod): boolean =>
  isOverDownloadPeriod(period) || isBeforeStartDate(period)

// 一覧から location.state で引き継いだ期間文字列（YYYY-MM-DD）を DownloadPeriod に復元する。
// 欠損・不正な日付は null を返し、呼び出し側で当日デフォルトにフォールバックさせる。
export const periodFromDateStrings = (
  dateFrom: string | undefined,
  dateTo: string | undefined
): DownloadPeriod | null => {
  if (!dateFrom || !dateTo) return null
  const start = moment(dateFrom, 'YYYY-MM-DD', true)
  const end = moment(dateTo, 'YYYY-MM-DD', true)
  if (!start.isValid() || !end.isValid()) return null
  return { startDate: start.toDate(), endDate: end.toDate() }
}

export const getYesterdayPeriod = (): DownloadPeriod => {
  const date = moment().subtract(1, 'days').toDate()
  return { startDate: date, endDate: date }
}

export const getTodayPeriod = (): DownloadPeriod => {
  const date = moment().toDate()
  return { startDate: date, endDate: date }
}

export const getLastMonthPeriod = (): DownloadPeriod => ({
  startDate: moment().subtract(1, 'months').startOf('month').toDate(),
  endDate: moment().subtract(1, 'months').endOf('month').toDate(),
})

export const getCurrentMonthPeriod = (): DownloadPeriod => ({
  startDate: moment().startOf('month').toDate(),
  endDate: moment().toDate(),
})

export const toCreatedAtRange = (period: DownloadPeriod): { from: string; to: string } => ({
  from: moment(period.startDate).format('YYYY-MM-DD[T]00:00:00'),
  to: moment(period.endDate).format('YYYY-MM-DD[T]23:59:59'),
})

export const buildDefaultCsvFilename = (period: DownloadPeriod): string =>
  `delivery_report_${moment(period.startDate).format(FORMAT_DATE)}_${moment(period.endDate).format(
    FORMAT_DATE
  )}.csv`
